import { uri } from '../../api-endpoint';
import {
  ILoginAPIValidationError,
  ILoginFromAPISuccessResponse
} from '../../type-conversion/login/from-api-repsonse';
import { LoginAPIRequestBody } from '../../type-conversion/login/to-api-request-body';
import { FetchResultType } from '../../types/common/fetch-result';
import { LoginAPIRequestBodyType } from '../../types/login-response/api-request-body';
import {
  LoginAPIRawSuccessResponseType,
  LoginAPIRawValidationErrorType
} from '../../types/login-response/api-response';
import { errorResponseConverterGenerator } from '../common/base/fetch/error-response-converter-generator';
import { fetchJson } from '../common/base/fetch/fetch-json';
import { mapFetchResult } from '../common/base/fetch/map-fetch-result';

export const fetchTokenAndUserDetail = async (
  body: LoginAPIRequestBodyType
) => {
  const result = await fetchJson({
    uri: uri.login,
    method: 'POST',
    body: LoginAPIRequestBody(body)
  });

  return mapFetchResult(
    result as FetchResultType<
      LoginAPIRawSuccessResponseType,
      LoginAPIRawValidationErrorType
    >,
    ILoginFromAPISuccessResponse,
    errorResponseConverterGenerator(ILoginAPIValidationError)
  );
};
